import React, { useContext } from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import Image from "next/image";
import { TextContext } from "@pages/bereken-bijdrage";


const Pilot = (props: any) => {
  const theme = useTheme();
  const text = useContext(TextContext);
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%" maxWidth="700px">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginTop="35px"
        marginBottom="30px"
      >
        <Typography variant="h2" align="center" gutterBottom>
          {text.headTitle}
        </Typography>
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          style={{ color: theme.palette.primary.light }}
        >
          {text.subTitle}
        </Typography>
      </Box>

      <Image height="150px" width="250px" src="/images/undraw_slidersGirl.svg" />
    </Box>
  );
};

export default Pilot;
